import theme from "@monorepo/styles/theme";
import { styled, Typography } from "@mui/material";

import { ITitleProps } from "./Title";

export const StyledTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "noMaxWidth" && prop !== "sx",
})<ITitleProps>(({ noMaxWidth }) => ({
  margin: "0 auto",
  marginBottom: theme.spacing(3),
  fontWeight: "bold",
  textAlign: "center",
  color: theme.palette.text.primary,
  maxWidth: noMaxWidth ? "100%" : "",
  wordBreak: "break-word",
  wordWrap: "break-word",
}));
